<template>
  <CustomModal
    disableCancel
    :modal="modal"
    @confirm="toggle"
    :data="confirmData"
  >
    <template v-slot:header>
      <div v-if="detail">
        {{ detail.title }}
      </div>
    </template>
    <template v-slot:body>
      <div class="container" v-if="detail">
        <div v-html="detail.content" />
      </div>
    </template>
  </CustomModal>
</template>

<script>
import CustomModal from "@/components/Modal";

export default {
  components: {
    CustomModal,
  },
  props: {
    confirmData: {
      type: Object,
      default: () => ({
        confirmText: "ปิด",
      }),
    },
    detail: {
      type: Object,
    },
    modal: {
      type: Boolean,
      default: false,
    },
    toggle: {
      type: Function,
    },
  },
};
</script>